import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { getAllTransactions } from "../../../api/transaction";
import { getAllDisputes } from "../../../api/order/disputes-admin";
import {
  getAllOrders,
  getDisputeList,
  getOrders,
  searchOrders,
} from "../../../api/order";
import { Pagination } from "@mui/material";
import { useLocation } from "react-router-dom";
import { getAllOrderTrackings } from "../../../api/order/order-tracking";
import { authSelector } from "../../../redux/slices/authSlice";
import { setOrderTablePage } from "../../../redux/slices/orderSlice";

export default function AdminTablesPagination({
  title,
  count,
  storeId,
  status,
  start_date,
  end_date,
  setPaginatePage,
  searchText,
}) {
  const dispatch = useDispatch();
  const { loggedUser } = useSelector(authSelector);
  const [page, setPage] = React.useState(1);
  const location = useLocation().pathname;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (title === "order_tracking") {
      dispatch(
        getAllOrderTrackings({
          page: newPage - 1,
          status: status,
          start_date: start_date,
          end_date: end_date,
        })
      );
    }

    if (location === "/customer/orders/dispute-list") {
      dispatch(
        getDisputeList({ page: newPage - 1, size: 50, storeId: storeId })
      );
    }
    if (location === "/customer/orders") {
      dispatch(setOrderTablePage(newPage));
      dispatch(getOrders({ page: newPage - 1, size: 50, status: status }));
      setPaginatePage(newPage - 1);
    } else if (loggedUser?.user?.role === "admin") {
      if (title === "orders") {
        if (searchText) {
          dispatch(searchOrders({ text: searchText, page: newPage - 1 }));
        } else {
          dispatch(
            getAllOrders({
              page: newPage - 1,
              limit: 50,
              storeId: storeId,
              status: status,
            })
          );
        }
      }
      if (title === "transactions") {
        dispatch(
          getAllTransactions({
            page: newPage - 1,
            size: 50,
            storeId: storeId,
          })
        );
      }
      if (title === "disputes") {
        dispatch(
          getAllDisputes({ page: newPage - 1, size: 50, storeId: storeId })
        );
      }
    }
  };

  return (
    <Pagination
      onChange={handleChangePage}
      sx={{
        ".MuiPagination-root": {
          ".Mui-selected": {
            backgroundColor: "#8D40FF",
            color: "#fff",
          },
        },
      }}
      defaultPage={page || 1}
      // page={page}
      count={Math.ceil(count / 50)}
      shape="rounded"
    />
  );
}
